import React from 'react';
import SvgIcon from './SvgIcon';

const NewEmail = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M12 18H.75V4.5H21v8.625"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M.75 4.5l10.125 7.725L21 4.5M20.25 17.625H15M17.625 15v5.25V15zM17.625 23.25a5.625 5.625 0 100-11.25 5.625 5.625 0 000 11.25z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

NewEmail.displayName = 'NewEmailIcon';

export default NewEmail;
